import { render, staticRenderFns } from "./TabMyAccount.vue?vue&type=template&id=43637634&scoped=true"
import script from "./TabMyAccount.vue?vue&type=script&lang=ts"
export * from "./TabMyAccount.vue?vue&type=script&lang=ts"
import style0 from "./TabMyAccount.vue?vue&type=style&index=0&id=43637634&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43637634",
  null
  
)

export default component.exports